import { useContext } from 'react';

import { ExtensionStateContext } from './context';
import { ExtensionStatus } from './types';

/**
 * A hook to fetch the current status of the extension.
 * It uses a global context to share polled data from the extension.
 *
 * @returns An object containing the extension state and a fetch function.
 */
const useExtensionState = () => {
  const { extensionState, fetch } = useContext(ExtensionStateContext);

  return {
    ...extensionState,
    isRecording: extensionState.status === ExtensionStatus.RECORDING,
    /**
     * Fetches the latest extension state by sending the `getExtensionState` browser message that the extension listens for.
     *
     * The extension state is polled at interval `EXTENSION_STATE_POLL_INTERVAL`, so you don't need to call this manually unless you want to force an immediate update.
     */
    fetch
  };
};

export default useExtensionState;
